import { useCallback } from 'react';

import { useMutation } from '@apollo/client';
import * as Sentry from '@sentry/react';
import type { LearnerOnboarding_ModularOnboardingInteractionType as ModularOnboardingInteraction } from '__generated__/graphql-types';

import SetModularOnboardingInteraction from 'bundles/onboarding-common/queries/SetModularOnboardingInteraction.graphql';
import type {
  SetModularOnboardingInteractionMutation,
  SetModularOnboardingInteractionMutationVariables,
} from 'bundles/onboarding-common/queries/__generated__/SetModularOnboardingInteraction';

const useSetOnboardingModuleInteraction = () => {
  const [mutation] = useMutation<
    SetModularOnboardingInteractionMutation,
    SetModularOnboardingInteractionMutationVariables
  >(SetModularOnboardingInteraction, {
    context: { clientName: 'gatewayGql' },
  });

  const setOnboardingModuleInteraction = useCallback<
    (interactionType: ModularOnboardingInteraction, handleErrorTracking?: () => void) => Promise<void>
  >(
    async (interactionType, handleErrorTracking) => {
      try {
        await mutation({
          variables: { input: { type: interactionType } },
        });
      } catch (error) {
        Sentry.captureMessage('[Modular Onboarding]: Unable to set onboarding module interaction', {
          extra: { error },
        });
        handleErrorTracking?.();
      }
    },
    [mutation]
  );

  return {
    setOnboardingModuleInteraction,
  };
};

export default useSetOnboardingModuleInteraction;
